<template>
  <header class="page-header" ref="headerRef" :style="{ backgroundColor: isScrolling ? '#28292b' : '' }">
    <!-- 左侧网站logo -->
    <div class="header-left" @click="menuClick(menus[0])">
      <img src="@/assets/images/logo.png" alt="网站logo" class="logo" />
      <div class="company-name">
        <p class="company-name-cn">合肥祝瑭机电科技有限公司</p>
        <p class="company-name-en">HE FEI ZHU TANG JI DIAN KE JI YOU XIAN GONG SI</p>
      </div>
    </div>
    <!-- 中间导航菜单 -->
    <nav class="header-right">
      <ul class="main-menu">
        <li v-for="menu in menus" :key="menu.id" class="menu-item">
          <span
            class="item-text"
            :class="{ 'active-item': (menu.link == '/' && menu.link == currentPath) || (menu.link != '/' && currentPath.includes(menu.link)) }"
            @click="menuClick(menu)"
          >
            {{ menu.name }}
          </span>
          <div class="active" v-if="(menu.link == '/' && menu.link == currentPath) || (menu.link != '/' && currentPath.includes(menu.link))"></div>
        </li>
      </ul>
    </nav>
    <div class="mobile-header-right" v-if="false">
      <i class="el-icon-menu menu-icon" @click="drawerVisible = true" v-if="!drawerVisible" />
      <i class="el-icon-close menu-icon" @click="drawerVisible = false" v-else />
      <el-drawer
        :visible.sync="drawerVisible"
        direction="ttb"
        :append-to-body="true"
        :with-header="false"
        custom-class="header-menu-drawer"
        :modal="false"
        style="top: 60px"
      >
        <div class="drawer-body">
          <ul class="main-menu-vertical">
            <li
              v-for="menu in menus"
              :key="menu.id"
              class="menu-vertical-item"
              :class="{
                'active-vertical-item': (menu.link == '/' && menu.link == currentPath) || (menu.link != '/' && currentPath.includes(menu.link)),
              }"
              @click="menuClick(menu)"
            >
              <span class="item-text">
                {{ menu.name }}
              </span>
              <div
                class="active"
                v-if="(menu.link == '/' && menu.link == currentPath) || (menu.link != '/' && currentPath.includes(menu.link))"
              ></div>
            </li>
          </ul>
        </div>
      </el-drawer>
    </div>
    <!-- 右侧登录及注册按钮 -->
    <!-- <div class="header-right">
      <button class="login-btn">登录</button>
      <button class="register-btn">注册</button>
    </div> -->
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  data() {
    return {
      currentId: 1,
      currentPath: '/',
      menus: [
        {
          id: 1,
          name: '首页',
          link: '/',
          children: null,
        },
        {
          id: 2,
          name: '关于我们',
          link: '/about',
          children: null,
        },
        {
          id: 3,
          name: '产品中心',
          link: '/products',
        },
        {
          id: 4,
          name: '案例中心',
          link: '/cases',
        },
        {
          id: 5,
          name: '新闻中心',
          link: '/news',
        },
        {
          id: 6,
          name: '荣誉资质',
          link: '/honor',
        },
      ],
      isScrolling: false, // 滚动状态
      drawerVisible: false,
    };
  },
  computed: {
    // 监听路由变化
    getCurrentPath() {
      return this.$route.path;
    },
  },
  watch: {
    getCurrentPath(val) {
      console.log('🚀 ~ val:', val);
      this.currentPath = val;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    menuClick(menu) {
      this.drawerVisible = false;
      this.currentId = menu.id;
      this.currentPath = menu.link;
      this.$router.push(menu.link);
    },
    handleScroll() {
      const headerRef = this.$refs.headerRef;
      if (headerRef) {
        const scrollTop = window.scrollY;
        const headerHeight = headerRef.clientHeight;
        const isScrolling = scrollTop > headerHeight;
        this.isScrolling = isScrolling;
        this.$emit('update:isScrolling', isScrolling);
      }
    },
  },
};
</script>

<style lang="scss">
.header-menu-drawer {
  height: calc(100% - 0px) !important;
  // top: 60px;
  background-color: transparent;
  .drawer-body {
    padding: 20px;
    color: #223865;
    background-color: #fff;
    .menu-vertical-item {
      padding: 0 20px;
      line-height: 56px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        background-color: #f6f8fd;
      }
    }
    .active-vertical-item {
      background-color: #f6f8fd;
    }
  }
}
</style>
<style scoped lang="scss">
.page-header {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // padding: 0 220px;
  background-color: transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  z-index: 9;
}

.header-left,
.header-middle,
.header-right {
  display: flex;
  align-items: center;
}
.header-left {
  cursor: pointer;
  .company-name {
    color: #fff;
    margin-left: 10px;
    .company-name-cn {
      font-weight: 60;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: 1px;
    }
    .company-name-en {
      opacity: .6;
      font-weight: 500;
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.logo {
  height: 72px;
  width: auto;
}

.main-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.menu-item {
  position: relative;
  margin: 0 35px;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  .item-text {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    position: relative;
    cursor: pointer;
    color: #fff;
    font-weight: 400;
    font-size: 18px;
    &:hover { 
      font-weight: 600;
    }
  }
  .active-item {
    font-weight: 600;
  }
  .active {
    width: 100%;
    height: 3px;
    border-radius: 3px;
    background-color: #cc0908;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

.mobile-header-right {
  display: none;
  .menu-icon {
    vertical-align: middle;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
}

/* 响应式布局 */
// @media screen and (max-width: 1000px) {
//   .header-right {
//     display: none;
//   }
//   .mobile-header-right {
//     display: block;
//   }
// }
</style>
